import { render } from "./InjuryTypeEdit.vue?vue&type=template&id=98d773bc&scoped=true"
import script from "./InjuryTypeEdit.vue?vue&type=script&lang=js"
export * from "./InjuryTypeEdit.vue?vue&type=script&lang=js"

import "./InjuryTypeEdit.vue?vue&type=style&index=0&id=98d773bc&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d773bc"]])

export default __exports__